import { NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import FlowerTitle from "../../components/ui/FlowerTitle";
const System = () => { 

  return (
    <div className="page-container">
      
    <FlowerTitle text="Système"/>
      <div className="page-nav">
        <NavLink to="combat">
          <Button text="Systèmes de combat" color="red"/>
        </NavLink>
        <NavLink to="leveling">
          <Button text="Système de progression" color="blue"/>
        </NavLink>
      </div>
      <Outlet/>
      <div className="page-nav">
        <NavLink to="combat">
          <Button text="Systèmes de combat" color="red"/>
        </NavLink>
        <NavLink to="leveling">
          <Button text="Système de progression" color="blue"/>
        </NavLink>
      </div>
    </div>
  )
}

export default System;